module.exports = {
     "report_url": "https://rs.litedev.com/",
    "tele_medicine_services_url": 'https://tms.litedev.com/',
    "al_dawa_url": "https://pnds.litedev.com/",
    "captain_url": "https://cflow.litedev.com/",
    "oh_url": "https://ophub.litedev.com",
    "chs_url": "https://chs.litedev.com",
    "ph_url": "https://phub.litedev.com",
    "com_url": "https://chub.litedev.com",
    "auth_url": "https://auth.litedev.com",
    "invoiceDate": "2021-09-06",
    "VAT": 0.15,
    "pharmacy_url":"https://pharmacy.litedev.com",
    "website_url":"https://sanarweb.litedev.com/",
    "jwtSecret": "fgxzbmvhgkiteqw135rodjdxff+=sdhbkvnxzm+=",
    "encryptedKey": "fsfhjkgweer+12fbmvngdvdfr+==",
    "socketHub": "https://socketdev.litedev.com",
    "fd_url":"https://fhub.litedev.com/admin",
    "caregiver_url": "https://caregiver.litedev.com",
    tawuniya_packages: ["SN2555"],
    "medgulf_packages": ["MPK42","MPK43"],
    "img_url":"https://img.litedev.com/",
    "fileupload_url":"https://imgpre.litedev.com/",
    "pre_employement_url":"https://employees.litedev.com",
    "notification":"https://notifications.litedev.com",
    "AlRajhi_Takaful": ["MPK573", "MPK574", "MPK575", "MPK576", "MPK577", "MPK578", "MPK579", "MPK580", "MPK581", "MPK582", "MPK583"],
    tawuniya_credit: {TAWUNIYA_CREDIT: 'Tawuniya'},
    "imgcompress_url": "https://img.sanar.sa/",
    "waseel_url": "https://waseelapi.litedev.com",
    labPackages: [{id: 'HSP154',name: 'Sanar Lab'}, {id: 'HSP155',name: 'Al Mostaqbal Lab'}],
    "corporate_url": "https://corporate-wellness.litedev.com",
    mapKey: "AIzaSyDI4JZokaSeLz0Qn5fAQZ-O0erb1wH1awA",
    version: "21042023",
 sanar_ai: 'https://sanarai.litedev.com/',
    "blood_donation": "https://bdp.litedev.com/",
    "physio_session": "https://pts.litedev.com/",
    "nurse_subscription_url": "https://nvs.litedev.com/",
    "invoice_url": "https://invoice.litedev.com",
    "user_services_url": "https://userservices.litedev.com/",
    "opertaion_url": 'https://operations.litedev.com/',
    "entity_Id": "HSP94",
    "login_id": ["SNR999"],
    "preEmployment": ["MPK595", "MPK632", "MPK728"],
    "event_id": "1161",
    "creditUserWithPrice": {
        "ST04": ["CUS/00077"],
        "ST037": ["CUS/00063", "ALJIBrokers", "AON"]
    },
    "creditUserWithPriceHSP": {
        "ST04": ["HSP182"],
        "ST037": ["HSP148"]
    },
    "home_visit_doctor_url": "https://hvd.litedev.com/",
    "edit_location_date": "1st Mar 2025, 12:00:00 AM",
    "cms_url": "https://cms.litedev.com/"
}


//////////////////
// WEBPACK FOOTER
// ./config/endpoints.js
// module id = VPkb
// module chunks = 86